import { Helmet } from 'react-helmet';
import { 
  FaSchool,
  FaChalkboardTeacher,
  FaUserGraduate,
  FaHeart,
  FaBook,
  FaFlask,
  FaLaptop,
  FaFutbol,
  FaMusic,
  FaUtensils,
  FaHeartbeat,
  FaLeaf,
  FaHome,
  FaTrophy,
  FaUsers,
  FaGraduationCap,
  FaAward,
  FaShieldAlt,
  FaRegClock,
  FaRegBuilding,
  FaRegCalendarAlt,
  FaRegLightbulb,
  FaRegStar,
  FaQuoteRight,
  FaArrowRight,
  FaCheckCircle
} from 'react-icons/fa';
import { title as siteTitle } from '../constants/constant';
import Layout from '../components/layout/Layout';
import BreadcrumbImg from '../assets/images/breadcrumb.png';

// Constants Data
const breadcrumbData = {
  home: { text: "Home", path: "/" },
  current: "About Us",
  title: "About Us",
  image: BreadcrumbImg
};

const statsData = [
  {
    id: 1,
    icon: FaGraduationCap,
    value: "Pre-10",
    label: "Complete Education",
    bgColor: "bg-blue-50",
    iconColor: "text-blue-600",
    hoverBg: "hover:bg-blue-100",
    borderColor: "border-blue-200"
  },
  {
    id: 2,
    icon: FaAward,
    value: "CBSE",
    label: "Board Affiliation",
    bgColor: "bg-emerald-50",
    iconColor: "text-emerald-600",
    hoverBg: "hover:bg-emerald-100",
    borderColor: "border-emerald-200"
  },
  {
    id: 3,
    icon: FaUsers,
    value: "25+",
    label: "Expert Faculty",
    bgColor: "bg-purple-50",
    iconColor: "text-purple-600",
    hoverBg: "hover:bg-purple-100",
    borderColor: "border-purple-200"
  },
  {
    id: 4,
    icon: FaHeart,
    value: "500+",
    label: "Happy Students",
    bgColor: "bg-amber-50",
    iconColor: "text-amber-600",
    hoverBg: "hover:bg-amber-100",
    borderColor: "border-amber-200"
  }
];

const featuresData = [
  {
    id: 1,
    title: "Academic Excellence",
    description: "Comprehensive CBSE curriculum from Pre to Class 10",
    icon: FaSchool,
    color: "blue",
    borderColor: "border-blue-200",
    bgGradient: "from-blue-50 to-blue-100",
    iconBg: "bg-white",
    iconColor: "text-blue-600",
    points: [
      { text: "CBSE Curriculum", icon: FaCheckCircle },
      { text: "Smart Classes", icon: FaCheckCircle },
      { text: "Regular Tests", icon: FaCheckCircle },
      { text: "Result Analysis", icon: FaCheckCircle }
    ]
  },
  {
    id: 2,
    title: "Holistic Development",
    description: "Balanced focus on academics and personality",
    icon: FaHeart,
    color: "emerald",
    borderColor: "border-emerald-200",
    bgGradient: "from-emerald-50 to-emerald-100",
    iconBg: "bg-white",
    iconColor: "text-emerald-600",
    points: [
      { text: "Sports Activities", icon: FaCheckCircle },
      { text: "Art & Music", icon: FaCheckCircle },
      { text: "Life Skills", icon: FaCheckCircle },
      { text: "Yoga Classes", icon: FaCheckCircle }
    ]
  },
  {
    id: 3,
    title: "Digital Learning",
    description: "Technology integrated smart education",
    icon: FaLaptop,
    color: "purple",
    borderColor: "border-purple-200",
    bgGradient: "from-purple-50 to-purple-100",
    iconBg: "bg-white",
    iconColor: "text-purple-600",
    points: [
      { text: "Computer Lab", icon: FaCheckCircle },
      { text: "Smart Boards", icon: FaCheckCircle },
      { text: "Digital Content", icon: FaCheckCircle },
      { text: "Project Work", icon: FaCheckCircle }
    ]
  },
  {
    id: 4,
    title: "Safe Environment",
    description: "Secure and caring campus atmosphere",
    icon: FaShieldAlt,
    color: "amber",
    borderColor: "border-amber-200",
    bgGradient: "from-amber-50 to-amber-100",
    iconBg: "bg-white",
    iconColor: "text-amber-600",
    points: [
      { text: "CCTV Surveillance", icon: FaCheckCircle },
      { text: "Medical Room", icon: FaCheckCircle },
      { text: "Clean Campus", icon: FaCheckCircle },
      { text: "Trained Staff", icon: FaCheckCircle }
    ]
  }
];

const facilitiesData = [
  {
    id: 1,
    name: "Library",
    description: "Books & Resources",
    icon: FaBook,
    bgColor: "bg-gray-50",
    hoverColor: "hover:bg-blue-50",
    iconBg: "bg-white",
    iconColor: "text-blue-600"
  },
  {
    id: 2,
    name: "Science Lab",
    description: "Practical Learning",
    icon: FaFlask,
    bgColor: "bg-gray-50",
    hoverColor: "hover:bg-blue-50",
    iconBg: "bg-white",
    iconColor: "text-emerald-600"
  },
  {
    id: 3,
    name: "Sports",
    description: "Games & Fitness",
    icon: FaFutbol,
    bgColor: "bg-gray-50",
    hoverColor: "hover:bg-blue-50",
    iconBg: "bg-white",
    iconColor: "text-red-600"
  },
  {
    id: 4,
    name: "Music Room",
    description: "Arts Education",
    icon: FaMusic,
    bgColor: "bg-gray-50",
    hoverColor: "hover:bg-blue-50",
    iconBg: "bg-white",
    iconColor: "text-purple-600"
  },
  {
    id: 5,
    name: "Computer Lab",
    description: "Digital Skills",
    icon: FaLaptop,
    bgColor: "bg-gray-50",
    hoverColor: "hover:bg-blue-50",
    iconBg: "bg-white",
    iconColor: "text-indigo-600"
  },
  {
    id: 6,
    name: "Activity Room",
    description: "Creative Space",
    icon: FaRegBuilding,
    bgColor: "bg-gray-50",
    hoverColor: "hover:bg-blue-50",
    iconBg: "bg-white",
    iconColor: "text-amber-600"
  }
];

const missionData = {
  mission: {
    title: "Our Mission",
    text: "To provide quality education that develops academic skills, moral values, and social responsibility in every student.",
    icon: FaRegStar,
    bgColor: "bg-blue-50",
    borderColor: "border-blue-100",
    dotColor: "bg-blue-400"
  },
  vision: {
    title: "Our Vision",
    text: "To create a learning environment that fosters excellence, creativity, and prepares students for future challenges.",
    icon: FaRegLightbulb,
    bgColor: "bg-emerald-50",
    borderColor: "border-emerald-100",
    dotColor: "bg-emerald-400"
  },
  approach: {
    title: "Educational Approach",
    text: "Child-centered learning with focus on conceptual understanding, practical knowledge, and application-based education.",
    icon: FaRegClock,
    bgColor: "bg-purple-50",
    borderColor: "border-purple-100",
    dotColor: "bg-purple-400"
  }
};

const schoolInfoData = {
  classes: "Pre-Nursery to Class 10",
  curriculum: "CBSE (Central Board of Secondary Education)",
  focusAreas: "Academics, Sports, Arts, Discipline",
  teachingMethod: "Interactive & Activity-based",
  assessment: "Regular Tests & Progress Reports",
  environment: "Safe, Clean & Conducive to Learning"
};

const philosophyData = {
  quote: "Education is the foundation upon which we build our future. We aim to provide quality education that shapes character and builds confident individuals.",
  author: "School Values"
};

export default function About() {
  return (
    <Layout>
      <Helmet>
        <title>About Us | {siteTitle}</title>
        <meta name="description" content="Learn about Gyan Rashmi - Our mission, vision, facilities, and commitment to quality education from Pre-Nursery to Class 10." />
      </Helmet>

      {/* Breadcrumb Section - Full width */}
      <div className="relative bg-gray-900">
        <div className="h-48 md:h-56">
          <img 
            alt="Breadcrumb" 
            className="object-cover w-full h-full opacity-60" 
            src={breadcrumbData.image} 
          />
          <div className="absolute inset-0 bg-black/50"></div>
        </div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
          <div className="flex items-center mb-3 text-sm text-white">
            <a 
              href={breadcrumbData.home.path} 
              className="flex items-center transition-colors hover:text-gray-200"
            >
              <FaHome className="w-4 h-4 mr-2" />
              {breadcrumbData.home.text}
            </a>
            <span className="mx-2">/</span>
            <span className="font-semibold">{breadcrumbData.current}</span>
          </div>
          <h1 className="text-3xl font-bold text-white md:text-4xl">{breadcrumbData.title}</h1>
        </div>
      </div>

      {/* Main Content - Container with max-w-7xl */}
      <div className="px-4 py-8 mx-auto max-w-7xl sm:px-6 lg:px-8 md:py-12">
        {/* Welcome Section */}
        <div className="max-w-3xl mx-auto mb-8 text-center md:mb-12">
          <h2 className="mb-3 text-2xl font-bold text-gray-900 md:text-3xl">Welcome to Our School</h2>
          <p className="text-gray-700 md:text-lg">
            We provide quality CBSE education from Pre-Nursery to Class 10, focusing on academic excellence, 
            discipline, and all-round development. Our dedicated faculty and modern facilities create an 
            ideal learning environment.
          </p>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-2 gap-3 mb-8 md:grid-cols-4 md:gap-4 md:mb-12">
          {statsData.map((stat) => (
            <div 
              key={stat.id}
              className={`p-4 text-center rounded-lg border border-gray-200 ${stat.bgColor} transition-all duration-300 hover:shadow-lg hover:scale-[1.03] ${stat.hoverBg} relative overflow-hidden group`}
            >
              <div className="absolute inset-0 transition-transform duration-700 -translate-x-full bg-gradient-to-r from-transparent via-white/10 to-transparent group-hover:translate-x-full"></div>
              <div className="relative">
                <div className={`inline-flex items-center justify-center w-12 h-12 rounded-full ${stat.bgColor} mb-3 group-hover:scale-110 transition-transform duration-300`}>
                  <stat.icon className={`w-6 h-6 ${stat.iconColor}`} />
                </div>
                <div className="text-xl font-bold text-gray-900 md:text-2xl">{stat.value}</div>
                <div className="text-sm text-gray-600 md:text-base">{stat.label}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Key Features */}
        <div className="mb-8 md:mb-12">
          <h3 className="mb-6 text-xl font-bold text-center text-gray-900 md:text-2xl">Our Key Features</h3>
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
            {featuresData.map((feature) => (
              <div 
                key={feature.id}
                className={`relative overflow-hidden p-5 rounded-lg border ${feature.borderColor} bg-gradient-to-br ${feature.bgGradient} transition-all duration-300 hover:shadow-xl hover:-translate-y-1 group`}
              >
                <div className="absolute inset-0 transition-transform duration-1000 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent group-hover:translate-x-full"></div>
                <div className="relative">
                  <div className="flex items-start gap-3 mb-3">
                    <div className={`p-2 rounded-md ${feature.iconBg} ${feature.iconColor} group-hover:scale-110 transition-transform duration-300`}>
                      <feature.icon className="w-5 h-5 md:w-6 md:h-6" />
                    </div>
                    <div>
                      <h4 className="text-base font-bold text-gray-900 md:text-lg">{feature.title}</h4>
                      <p className="mt-1 text-sm text-gray-700">{feature.description}</p>
                    </div>
                  </div>
                  <div className="space-y-2">
                    {feature.points.map((point, index) => (
                      <div key={index} className="flex items-center gap-2 transition-transform duration-200 group/item hover:translate-x-1">
                        <point.icon className={`w-3 h-3 text-${feature.color}-600`} />
                        <span className="text-sm text-gray-700">{point.text}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Facilities and Mission/Vision */}
        <div className="grid gap-6 mb-8 md:grid-cols-2 md:mb-12">
          {/* Facilities */}
          <div className="p-5 transition-shadow duration-300 bg-white border border-gray-200 rounded-lg hover:shadow-md">
            <div className="flex items-center gap-2 mb-4">
              <FaSchool className="w-5 h-5 text-blue-600" />
              <h3 className="text-lg font-bold text-gray-900">Our Facilities</h3>
            </div>
            <div className="grid grid-cols-2 gap-3">
              {facilitiesData.map((facility) => (
                <div 
                  key={facility.id}
                  className={`flex items-center gap-2 p-3 transition-colors duration-300 rounded-lg ${facility.bgColor} ${facility.hoverColor} hover:shadow-sm group`}
                >
                  <div className={`p-2 rounded-md ${facility.iconBg} ${facility.iconColor} group-hover:scale-110 transition-transform duration-200`}>
                    <facility.icon className="w-4 h-4" />
                  </div>
                  <div>
                    <div className="text-sm font-medium text-gray-900">{facility.name}</div>
                    <div className="text-xs text-gray-600">{facility.description}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Mission, Vision, Approach */}
          <div className="space-y-4">
            <div className={`p-5 transition-shadow duration-300 border rounded-lg ${missionData.mission.bgColor} ${missionData.mission.borderColor} hover:shadow-sm group`}>
              <div className="flex items-center gap-2 mb-2">
                <div className={`w-2 h-2 ${missionData.mission.dotColor} rounded-full`}></div>
                <h3 className="font-bold text-gray-900">{missionData.mission.title}</h3>
              </div>
              <p className="text-sm text-gray-700">{missionData.mission.text}</p>
            </div>

            <div className={`p-5 transition-shadow duration-300 border rounded-lg ${missionData.vision.bgColor} ${missionData.vision.borderColor} hover:shadow-sm group`}>
              <div className="flex items-center gap-2 mb-2">
                <div className={`w-2 h-2 ${missionData.vision.dotColor} rounded-full`}></div>
                <h3 className="font-bold text-gray-900">{missionData.vision.title}</h3>
              </div>
              <p className="text-sm text-gray-700">{missionData.vision.text}</p>
            </div>

            <div className={`p-5 transition-shadow duration-300 border rounded-lg ${missionData.approach.bgColor} ${missionData.approach.borderColor} hover:shadow-sm group`}>
              <div className="flex items-center gap-2 mb-2">
                <div className={`w-2 h-2 ${missionData.approach.dotColor} rounded-full`}></div>
                <h3 className="font-bold text-gray-900">{missionData.approach.title}</h3>
              </div>
              <p className="text-sm text-gray-700">{missionData.approach.text}</p>
            </div>
          </div>
        </div>

        {/* School Info */}
        <div className="p-5 mb-8 transition-shadow duration-300 border border-gray-200 rounded-lg bg-gray-50 md:p-6 hover:shadow-md">
          <h3 className="mb-4 text-lg font-bold text-center text-gray-900">About Our School</h3>
          <div className="grid gap-4 text-sm text-gray-700 md:grid-cols-2">
            <div>
              <p className="mb-3">
                <span className="font-semibold">Classes:</span> {schoolInfoData.classes}
              </p>
              <p className="mb-3">
                <span className="font-semibold">Curriculum:</span> {schoolInfoData.curriculum}
              </p>
              <p>
                <span className="font-semibold">Focus Areas:</span> {schoolInfoData.focusAreas}
              </p>
            </div>
            <div>
              <p className="mb-3">
                <span className="font-semibold">Teaching Method:</span> {schoolInfoData.teachingMethod}
              </p>
              <p className="mb-3">
                <span className="font-semibold">Assessment:</span> {schoolInfoData.assessment}
              </p>
              <p>
                <span className="font-semibold">Environment:</span> {schoolInfoData.environment}
              </p>
            </div>
          </div>
        </div>

        {/* Philosophy */}
        <div className="p-6 transition-shadow duration-300 border border-blue-100 rounded-lg bg-gradient-to-r from-blue-50 to-cyan-50 hover:shadow-md">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-2 bg-blue-100 rounded-full">
              <FaQuoteRight className="w-5 h-5 text-blue-600" />
            </div>
            <h3 className="text-lg font-bold text-gray-900">Our Philosophy</h3>
          </div>
          <p className="mb-2 text-sm italic text-gray-800 md:text-base">
            "{philosophyData.quote}"
          </p>
          <div className="text-sm font-medium text-blue-600">— {philosophyData.author}</div>
        </div>

        {/* Footer Note */}
        <div className="mt-8 text-center">
          <p className="text-sm text-gray-600">
            Committed to providing quality education and nurturing young minds since establishment.
          </p>
        </div>
      </div>
    </Layout>
  );
}